import { headers } from './constants';
import axios from 'axios';
import { LAST_REFRESH_DATE_URL, SETTINGS_URL } from 'constants/api';

export const appAPI = {
    fetchLastRefreshDate: () =>
        axios
            .get(`${LAST_REFRESH_DATE_URL}`, {
                headers
            })
            .then((response) => response.data),
    fetchSettings: () =>
        axios
            .get(`${SETTINGS_URL}`, {
                headers
            })
            .then((response) => response.data)
};
